import React from "react";
import { Document, Font, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { DacState, ServicesState, SitesState } from "../../../Store/Reducers/Dac/types";
import Logo from "../../../assets/Cover/Sayse.png";
import BgMain from "../../../assets/Cover/Cover.jpg";
import axios from "axios";

Font.register({ family: "PoppinsBold", src: "/font/Poppins-Bold.ttf" });
Font.register({ family: "PoppinsMedium", src: "/font/Poppins-Medium.ttf" });
Font.register({ family: "PoppinsRegular", src: "/font/Poppins-Regular.ttf" });
Font.register({ family: "PoppinsLight", src: "/font/Poppins-Light.ttf" });
Font.register({ family: "Poppins", src: "/font/Poppins-Black.ttf" });
Font.register({ family: "PoppinsItalic", src: "/font/Poppins-Italic.ttf" });

interface Props {
    order: DacState | null;
    Categories: Array<{ _id: string; name: string }>;
}

interface PagePdfState {
    update: boolean;
    durations: Array<{ label: string; id: string }>;
}

class PagePDF extends React.Component<Props, PagePdfState> {
    constructor(props: any) {
        super(props);
        this.state = {
            update: false,
            durations: [],
        };
    }

    componentDidMount() {
        this.getDurations();
    }

    getDurations = async () => {
        const res = await axios.get(
            "https://api.pipedrive.com/v1/dealFields/12465?api_token=92a31b515d71bcff39efa003d56b2978f2658e6e"
        );
        const durations = res.data.data.options;
        this.setState(() => ({
            durations: durations.map((d: { id: string; label: string }) => ({
                id: `${d.id}`,
                label: d.label,
            })),
        }));
    };

    categoryName = (id: string) => {
        const { Categories } = this.props;
        return Categories.filter((category) => category._id === id).length > 0
            ? Categories.filter((category) => category._id === id)[0].name
            : "";
    };

    categoryColor = (category: string) => {
        // if(category) {
        let color;
        switch (category.toUpperCase()) {
            case "UUCAAS":
                color = "#e74c3c";
                break;
            case "INTERNET":
                color = "#27ae60";
                break;
            case "INTEGRATION":
                color = "#2980b9";
                break;
            case "WIFI & SD-LAN":
                color = "#8e44ad";
                break;
            case "SD-WAN":
                color = "#e67e22";
                break;
            case "SPECIAL":
                color = "#f1c40f";
                break;
            default:
                color = "#A17917";
                break;
        }
        return color;
        // }
    };

    render() {
        const { order } = this.props;

        console.log("SOCIETY", order?.society);
        console.log("SOCIETY SITES", order?.sites);

        if (order) {
            const { society, sites, billing, clauses } = order;
            return (
                <Document>
                    <Page>
                        <Image src={BgMain} style={{ height: "100%", width: "100%", position: "absolute" }} fixed />
                        <View
                            style={{
                                color: "white",
                                textAlign: "center",
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <View style={{ marginBottom: 400 }}>
                                {/* <Text style={{ fontSize: 25, fontFamily: "PoppinsBold" }}>CONTRAT DE SERVICES</Text> */}
                                <Text style={{ color: "#2E5AE8", fontSize: 14, fontFamily: "PoppinsMedium" }}>
                                    #{society.id_pipedrive}
                                </Text>
                            </View>
                        </View>
                        <Text style={styles.pageNumber} render={() => ""} fixed />
                    </Page>
                    <Page style={{ paddingBottom: 45, paddingTop: 20 }} wrap={true}>
                        <View style={{ paddingLeft: "6%", paddingTop: "6%", paddingRight: "6%" }}>
                            <View style={styles.header}>
                                <View
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Image style={styles.logo} source={Logo} />
                                    <Text
                                        style={{
                                            marginTop: "auto",
                                            marginRight: "auto",
                                            fontSize: 9,
                                            // marginTop: 20,
                                            fontFamily: "PoppinsBold",
                                            color: "#1162d8",
                                        }}
                                    >
                                        Bon de commande n° : {society.id_order}
                                    </Text>
                                </View>
                                <View style={styles.txtInfoClient}>
                                    <View style={{ marginBottom: 8 }}>
                                        <Text style={styles.fontBold}>Date de commande : {society.order_date}</Text>
                                        <Text style={{ marginLeft: "auto", fontWeight: "bold" }}>
                                            Durée de souscription:{" "}
                                            {this.state.durations.find((d) => d.id === society.subscribe_duration)
                                                ?.label || ""}
                                        </Text>
                                    </View>
                                    <View style={{ marginBottom: 8 }}>
                                        <Text
                                            style={{
                                                marginLeft: "auto",
                                                fontWeight: "bold",
                                                backgroundColor: "#0058d4",
                                                color: "white",
                                                paddingLeft: 5,
                                                paddingRight: 5,
                                                paddingTop: 1,
                                                paddingBottom: 1,
                                            }}
                                        >
                                            ID: #{society.id_pipedrive}
                                        </Text>
                                        {society.old_id_pipedrive !== "" && (
                                            <Text style={{ marginLeft: "auto", fontWeight: "bold" }}>
                                                #Ancien ID: {society.old_id_pipedrive}
                                            </Text>
                                        )}
                                    </View>
                                    <View>
                                        <Text style={{ marginLeft: "auto" }}>{society.society}</Text>
                                        <Text
                                            style={{
                                                marginLeft: "auto",
                                                width: 160,
                                                textAlign: "right",
                                            }}
                                        >
                                            {society.address ? society.address : ""}
                                        </Text>
                                        <Text style={{ marginLeft: "auto" }}>
                                            {" "}
                                            {billing.contact_name ? billing.contact_name : ""}
                                        </Text>
                                        <Text style={{ marginLeft: "auto" }}>
                                            {" "}
                                            {billing.contact_tel ? billing.contact_tel : ""}
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={styles.body}>
                            {sites.map((site: SitesState, index: number) => {
                                // Create batches of services (5 per page)
                                const SERVICES_PER_PAGE = 6;
                                const serviceBatches = [];

                                for (let i = 0; i < site.services.length; i += SERVICES_PER_PAGE) {
                                    serviceBatches.push(site.services.slice(i, i + SERVICES_PER_PAGE));
                                }

                                // Render each batch as a separate site block with a page break between them
                                return (
                                    <React.Fragment key={index}>
                                        {serviceBatches.map((batch, batchIndex) => (
                                            <View
                                                style={[styles.ctnSite, { marginBottom: 15 }]}
                                                key={`${index}-${batchIndex}`}
                                                wrap={false}
                                                break={batchIndex > 0 || (index > 0 && batchIndex === 0)}
                                            >
                                                <View style={styles.siteContent} wrap={false}>
                                                    {/* Site header information - show on every batch */}
                                                    <View style={styles.footerSite} wrap={false}>
                                                        <View style={{ width: "70%" }}>
                                                            <View style={styles.footerCaseName}>
                                                                <Text
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        marginTop: "auto",
                                                                        marginBottom: "auto",
                                                                    }}
                                                                >
                                                                    Site concerné :{" "}
                                                                </Text>
                                                                <Text
                                                                    style={{
                                                                        backgroundColor: "#0058d4",
                                                                        paddingLeft: 5,
                                                                        paddingRight: 5,
                                                                        paddingTop: 1,
                                                                        paddingBottom: 1,
                                                                        color: "white",
                                                                        fontSize: 8,
                                                                    }}
                                                                >
                                                                    {site.site_name}
                                                                </Text>
                                                            </View>
                                                            <View style={{ marginTop: 5 }}>
                                                                    <Text
                                                                        style={{
                                                                            fontFamily: "PoppinsMedium",
                                                                            fontSize: 7,
                                                                        }}
                                                                    >
                                                                        Siret : {site.siret || ""}
                                                                    </Text>
                                                            </View>
                                                            <View style={{ marginTop: 5 }}>
                                                                <Text
                                                                    style={{ fontFamily: "PoppinsMedium", fontSize: 7 }}
                                                                >
                                                                    Adresse de livraison :{" "}
                                                                </Text>
                                                                <Text
                                                                    style={{ fontFamily: "PoppinsMedium", fontSize: 7 }}
                                                                >
                                                                    {site.delivery_address}
                                                                </Text>
                                                            </View>
                                                        </View>
                                                        <View
                                                            style={{
                                                                width: "30%",
                                                                display: "flex",
                                                                textAlign: "right",
                                                            }}
                                                        >
                                                            <Text
                                                                style={{ fontFamily: "PoppinsMedium", paddingTop: 5 }}
                                                            >
                                                                Nom du contact sur site
                                                            </Text>
                                                            <Text>{site.contact_name}</Text>
                                                            <Text>{site.contact_tel}</Text>
                                                            <Text>{site.contact_mail}</Text>
                                                        </View>
                                                    </View>

                                                    {/* Table header - show on every batch */}
                                                    <View style={styles.headerSite} wrap={false}>
                                                        <Text style={{ marginTop: "auto", fontSize: 7, width: "5%" }}>
                                                            Durée
                                                        </Text>
                                                        <Text
                                                            style={{
                                                                marginTop: "auto",
                                                                fontSize: 7,
                                                                width: "11%",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            Solution
                                                        </Text>
                                                        <Text style={{ marginTop: "auto", fontSize: 7, width: "30%" }}>
                                                            Description
                                                        </Text>
                                                        <View
                                                            style={{
                                                                marginTop: "auto",
                                                                fontSize: 7,
                                                                width: "10%",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            <Text style={{ color: "#1162d8" }}>Abo/Mois</Text>
                                                        </View>
                                                        <View
                                                            style={{
                                                                color: "#1162d8",
                                                                marginTop: "auto",
                                                                fontSize: 7,
                                                                width: "10%",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            <Text>Fas Unitaire</Text>
                                                        </View>
                                                        <Text
                                                            style={{
                                                                marginTop: "auto",
                                                                fontSize: 7,
                                                                width: "6%",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            Qté
                                                        </Text>
                                                        <View
                                                            style={{
                                                                marginTop: "auto",
                                                                fontSize: 7,
                                                                width: "10%",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            <Text>Total Abo</Text>
                                                        </View>
                                                        <View
                                                            style={{
                                                                marginTop: "auto",
                                                                fontSize: 7,
                                                                width: "10%",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            <Text>Total Fas</Text>
                                                        </View>
                                                    </View>

                                                    {/* Services in this batch */}
                                                    {batch.map((service: ServicesState, serviceIndex: number) => {
                                                        if (service) {
                                                            return (
                                                                <View
                                                                    key={serviceIndex}
                                                                    style={styles.row}
                                                                    wrap={false}
                                                                >
                                                                    <Text
                                                                        style={{
                                                                            width: "5%",
                                                                            color: "gray",
                                                                        }}
                                                                    >
                                                                        {
                                                                            this.state.durations.find(
                                                                                (d) => d.id === service.duration
                                                                            )?.label || ""
                                                                        }
                                                                    </Text>
                                                                    <View
                                                                        style={{
                                                                            width: "11%",
                                                                            marginTop: "auto",
                                                                            marginBottom: "auto",
                                                                        }}
                                                                    >
                                                                        <Text
                                                                            style={{
                                                                                color: "white",
                                                                                padding: 2,
                                                                                marginBottom: 5,
                                                                                textAlign: "center",
                                                                                backgroundColor: this.categoryColor(
                                                                                    service.family
                                                                                ),
                                                                            }}
                                                                        >
                                                                            {service.family}
                                                                        </Text>
                                                                    </View>
                                                                    <View
                                                                        style={{
                                                                            width: "30%",
                                                                            color: "gainsboro",
                                                                            marginTop: "auto",
                                                                            marginBottom: "auto",
                                                                        }}
                                                                    >
                                                                        <Text
                                                                            style={{
                                                                                width: "100%",
                                                                                textAlign: "left",
                                                                                marginBottom: 10,
                                                                                color: "gray",
                                                                            }}
                                                                        >
                                                                            {service.designation}
                                                                        </Text>
                                                                        <Text
                                                                            style={{
                                                                                width: "100%",
                                                                                textAlign: "left",
                                                                                marginLeft: "auto",
                                                                                color: "gray",
                                                                                fontFamily: "PoppinsItalic",
                                                                            }}
                                                                        >
                                                                            {service.describe_solution}
                                                                        </Text>
                                                                        <Text
                                                                            style={{
                                                                                width: "100%",
                                                                                textAlign: "left",
                                                                                marginLeft: "auto",
                                                                                marginTop: "5%",
                                                                                color:
                                                                                    service.status === "new"
                                                                                        ? "#1162d8" // Blue for new
                                                                                        : service.status === "existing"
                                                                                        ? "gray" // Gray for existing
                                                                                        : service.status === "upgrade"
                                                                                        ? "#2ecc71" // Green for upgrade
                                                                                        : "#e74c3c", // Red for replace
                                                                                fontFamily: "PoppinsBold",
                                                                            }}
                                                                        >
                                                                            {service.status === "new"
                                                                                ? "Nouveau Service"
                                                                                : service.status === "existing"
                                                                                ? "Service existant"
                                                                                : service.status === "upgrade"
                                                                                ? "Service à upgrader"
                                                                                : "Service à résilier " +
                                                                                  (service.notice_period
                                                                                      ? "(Préavis de " +
                                                                                        service.notice_period +
                                                                                        " mois)"
                                                                                      : "")}
                                                                        </Text>
                                                                    </View>
                                                                    <View
                                                                        style={{
                                                                            width: "10%",
                                                                            color: "gray",
                                                                            textAlign: "center",
                                                                            marginTop: "auto",
                                                                            marginBottom: "auto",
                                                                        }}
                                                                    >
                                                                        <Text style={{ color: "#1162d8" }}>
                                                                            {parseFloat(`${service.abo_ht}`).toFixed(2)}{" "}
                                                                            €
                                                                        </Text>
                                                                    </View>
                                                                    <View
                                                                        style={{
                                                                            width: "10%",
                                                                            color: "gray",
                                                                            textAlign: "center",
                                                                            marginTop: "auto",
                                                                            marginBottom: "auto",
                                                                        }}
                                                                    >
                                                                        <Text style={{ color: "#1162d8" }}>
                                                                            {parseFloat(`${service.fas_ht}`).toFixed(2)}{" "}
                                                                            €
                                                                        </Text>
                                                                    </View>
                                                                    <Text
                                                                        style={{
                                                                            width: "6%",
                                                                            color: "gray",
                                                                            textAlign: "center",
                                                                            marginTop: "auto",
                                                                            marginBottom: "auto",
                                                                        }}
                                                                    >
                                                                        {service.quantity}
                                                                    </Text>
                                                                    <View
                                                                        style={{
                                                                            width: "10%",
                                                                            color: "gray",
                                                                            textAlign: "center",
                                                                            marginTop: "auto",
                                                                            marginBottom: "auto",
                                                                        }}
                                                                    >
                                                                        <Text>
                                                                            {(
                                                                                parseFloat(`${service.abo_ht}`) *
                                                                                parseInt(`${service.quantity}`)
                                                                            ).toFixed(2)}{" "}
                                                                            €
                                                                        </Text>
                                                                    </View>
                                                                    <View
                                                                        style={{
                                                                            width: "10%",
                                                                            color: "gray",
                                                                            textAlign: "center",
                                                                            marginTop: "auto",
                                                                            marginBottom: "auto",
                                                                        }}
                                                                    >
                                                                        <Text>
                                                                            {(
                                                                                parseFloat(`${service.fas_ht}`) *
                                                                                parseInt(`${service.quantity}`)
                                                                            ).toFixed(2)}{" "}
                                                                            €
                                                                        </Text>
                                                                    </View>
                                                                </View>
                                                            );
                                                        } else {
                                                            return false;
                                                        }
                                                    })}

                                                    {/* Only show the total on the last batch */}
                                                    {batchIndex === serviceBatches.length - 1 && (
                                                        <View
                                                            style={{
                                                                width: "100%",
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                justifyContent: "space-between",
                                                                paddingTop: 14,
                                                            }}
                                                            wrap={false}
                                                        >
                                                            <View style={{ width: "5%" }}>
                                                                <Text
                                                                    style={{ fontSize: 9, fontFamily: "PoppinsBold" }}
                                                                >
                                                                    Total
                                                                </Text>
                                                            </View>
                                                            <View style={{ width: "11%" }} />
                                                            <View style={{ width: "30%" }} />
                                                            <View
                                                                style={{
                                                                    width: "10%",
                                                                    color: "gray",
                                                                    textAlign: "center",
                                                                    fontSize: 6,
                                                                    display: "flex",
                                                                    marginTop: "auto",
                                                                    marginBottom: "auto",
                                                                }}
                                                            ></View>
                                                            <View
                                                                style={{
                                                                    width: "10%",
                                                                    color: "gray",
                                                                    textAlign: "center",
                                                                    fontSize: 6,
                                                                    display: "flex",
                                                                    marginTop: "auto",
                                                                    marginBottom: "auto",
                                                                }}
                                                            ></View>
                                                            <View style={{ width: "6%" }} />
                                                            <View
                                                                style={{
                                                                    width: "10%",
                                                                    color: "gray",
                                                                    fontSize: 6,
                                                                    display: "flex",
                                                                    textAlign: "center",
                                                                    marginTop: "auto",
                                                                    marginBottom: "auto",
                                                                }}
                                                            >
                                                                <Text>{parseFloat(`${site.abo_ht}`).toFixed(2)} €</Text>
                                                            </View>
                                                            <View
                                                                style={{
                                                                    width: "10%",
                                                                    color: "gray",
                                                                    fontSize: 6,
                                                                    display: "flex",
                                                                    textAlign: "center",
                                                                    marginTop: "auto",
                                                                    marginBottom: "auto",
                                                                }}
                                                            >
                                                                <Text>{parseFloat(`${site.fas_ht}`).toFixed(2)} €</Text>
                                                            </View>
                                                        </View>
                                                    )}
                                                </View>
                                            </View>
                                        ))}
                                    </React.Fragment>
                                );
                            })}
                        </View>
                        <View
                            style={{ height: 1, marginRight: "8%", marginLeft: "8%", backgroundColor: "gainsboro" }}
                        />
                        <Text
                            style={styles.pageNumber}
                            render={({ pageNumber, totalPages }) => `
                                ${
                                    pageNumber > 1 && pageNumber < totalPages
                                        ? `
                                SAYSE SAS au capital de 17 566 € - RCS de Paris 801 891 722 00010 - Nº de TVA Intracommunautaire FR 03 801 891 722
                                Siège social : 10 rue de la Paix - 75002 PARIS - Tel : 0820 432 000 - www.sayse.fr - contact@sayse.fr
                                `
                                        : ""
                                }
                            `}
                            fixed
                        />
                    </Page>
                    <Page wrap>
                        <View style={styles.resumeWrapper}>
                            <View style={styles.contentPadding}>
                                <Text style={styles.resumeTitle}>Résumé de la commande:</Text>
                                <View style={styles.resumeContainer}>
                                    <View style={styles.resumeContent}>
                                        <View style={styles.headerRow} fixed>
                                            <Text style={styles.siteHeader}>Site</Text>
                                            <Text style={styles.aboHeader}>Abonnement mensuel HT</Text>
                                            <Text style={styles.fasHeader}>Frais d'Accès aux Services (FAS) HT</Text>
                                        </View>

                                        {sites.map((site: SitesState, i: number) => (
                                            <View key={i} style={styles.dataRow}>
                                                <Text style={styles.siteColumn}>
                                                    {i + 1}: {site.site_name}
                                                </Text>
                                                <Text style={styles.aboColumn}>
                                                    {parseFloat(`${site.abo_ht}`).toFixed(2)} €
                                                </Text>
                                                <Text style={styles.fasColumn}>
                                                    {parseFloat(`${site.fas_ht}`).toFixed(2)} €
                                                </Text>
                                            </View>
                                        ))}

                                        <View style={styles.totalRow}>
                                            <Text style={styles.totalLabel}>TOTAL HT</Text>
                                            <Text style={styles.totalAbo}>
                                                {parseFloat(`${society.abo_ht}`).toFixed(2)} €
                                            </Text>
                                            <Text style={styles.totalFas}>
                                                {parseFloat(`${society.fas_ht}`).toFixed(2)} €
                                            </Text>
                                        </View>
                                        <View style={styles.tvaRow}>
                                            <Text style={styles.totalLabel}>TOTAL TVA</Text>
                                            <Text style={styles.totalAbo}>
                                                {parseFloat(`${society.abo_ht * 0.2}`).toFixed(2)} €
                                            </Text>
                                            <Text style={styles.totalFas}>
                                                {parseFloat(`${society.fas_ht * 0.2}`).toFixed(2)} €
                                            </Text>
                                        </View>
                                        <View style={styles.totalRow}>
                                            <Text style={styles.totalLabel}>TOTAL TTC</Text>
                                            <Text style={styles.totalAbo}>
                                                {parseFloat(`${society.abo_ht * 1.2}`).toFixed(2)} €
                                            </Text>
                                            <Text style={styles.totalFas}>
                                                {parseFloat(`${society.fas_ht * 1.2}`).toFixed(2)} €
                                            </Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                            <Text
                                style={styles.baselineText}
                                render={({ pageNumber, totalPages }) => {
                                    console.log("pageNumber", pageNumber);
                                    console.log("totalPages", totalPages);
                                    const isLastResumePage = pageNumber === totalPages - 2;
                                    console.log("isLastResumePage", isLastResumePage);

                                    if (isLastResumePage) {
                                        return `
                                            SAYSE SAS au capital de 17 566 € - RCS de Paris 801 891 722 00010 - Nº de TVA Intracommunautaire FR 03 801 891 722
                                            Siège social : 10 rue de la Paix - 75002 PARIS - Tel : 0820 432 000 - www.sayse.fr - contact@sayse.fr
                                        `;
                                    }
                                    return "";
                                }}
                                fixed
                            />
                        </View>
                    </Page>
                    <Page style={{ paddingBottom: 45 }}>
                        <View style={{ width: "100%", display: "flex", padding: "8%" }}>
                            <View style={{ marginTop: 30 }}>
                                <View
                                    style={{
                                        fontSize: 9,
                                        textAlign: "left",
                                        fontFamily: "PoppinsBold",
                                        marginBottom: 15,
                                    }}
                                >
                                    <Text style={{ paddingLeft: 7 }}>Prestations complémentaires</Text>
                                </View>
                                <View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Configuration technique à distance</Text>
                                        <Text style={{ width: "45%", color: "gray" }}>90 Euros HT / 30 minutes</Text>
                                    </View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>
                                            Déplacement d'un technicien sur site, en Ile-de-France, 1 Heure incluse
                                        </Text>
                                        <Text style={{ width: "45%", color: "gray" }}>290 Euros HT/Demi-journée</Text>
                                    </View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Heure supplémentaire</Text>
                                        <Text style={{ width: "45%", color: "gray" }}>130 Euros HT</Text>
                                    </View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Intervention sur site, Hors Ile-de-France</Text>
                                        <Text style={{ width: "45%", color: "gray" }}>Sur devis</Text>
                                    </View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Forfait 4G(carte Sim interne)</Text>
                                        <View style={{ width: "45%", color: "gray" }}>
                                            <Text style={{ marginBottom: 5 }}>Jusqu'à 1Mo = inclus</Text>
                                            <Text style={{ marginBottom: 5 }}>Jusqu'à 100Mo = 20 Euros HT</Text>
                                            <Text style={{ marginBottom: 5 }}>Jusqu'à 500Mo = 30 Euros HT</Text>
                                            <Text style={{ marginBottom: 5 }}>Jusqu'à 3Go = 40 Euros HT</Text>
                                            <Text style={{ marginBottom: 5 }}>Jusqu'à 20Go = 70 Euros HT</Text>
                                        </View>
                                    </View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Services UCAAS</Text>
                                        <View style={{ width: "45%", color: "gray" }}>
                                            <Text style={{ marginTop: 5 }}>
                                                Transferts d'appels (Plus de 2heures): 0,23€ HT/min vers les fixes
                                            </Text>
                                            <Text style={{ marginTop: 5 }}>
                                                Transferts d'appels (Plus de 2heures): 0,23€ HT/min vers les mobiles
                                            </Text>
                                        </View>
                                    </View>
                                    <View
                                        style={{
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text>
                                            Dans le cas où le Client souhaite la mise en place de la solution SD-WAN de
                                            SAYSE, il faudrait procéder à l'ouverture des ports suivants vers internet:
                                        </Text>
                                        <View>
                                            <Text style={{ marginTop: 3 }}>*Ports TCP/UDP 15392</Text>
                                            <Text style={{ marginTop: 3 }}>*Ports TCP/UDP 53</Text>
                                            <Text style={{ marginTop: 3 }}>*Port UDP 123</Text>
                                            <Text style={{ marginTop: 3 }}>*Port TCP 21</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>

                            <View wrap={false}>
                                <View
                                    style={{
                                        marginTop: 30,
                                        textAlign: "left",
                                        fontSize: 9,
                                        fontFamily: "PoppinsBold",
                                        marginBottom: 15,
                                    }}
                                >
                                    <Text style={{ paddingLeft: 7 }}>
                                        Modalités de règlement des services et prestations
                                    </Text>
                                </View>
                                <View
                                    style={{
                                        paddingBottom: 5,
                                        borderBottomLeftRadius: 5,
                                        borderBottomRightRadius: 5,
                                    }}
                                >
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            border: "1px solid grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Mode de paiement</Text>
                                        <Text style={{ width: "45%", color: "gray" }}>Prélevement Automatique</Text>
                                    </View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Abonnements (ABO)</Text>
                                        <Text style={{ width: "45%", color: "gray" }}>
                                            Trimestriellement terme à échoir, à date de facture
                                        </Text>
                                    </View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Frais d'Accès aux Services (FAS)</Text>
                                        <Text style={{ width: "45%", color: "gray" }}>
                                            50% à la commande et 50% à la livraison de chaque service
                                        </Text>
                                    </View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Prestations (PRESTA)</Text>
                                        <Text style={{ width: "45%", color: "gray" }}>
                                            mensuellement terme échu, à date de facture
                                        </Text>
                                    </View>
                                    <View
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                            padding: 7,
                                            width: "100%",
                                            fontSize: 6,
                                        }}
                                    >
                                        <Text style={{ width: "55%" }}>Consommations (CONSO)</Text>
                                        <Text style={{ width: "45%", color: "gray" }}>
                                            mensuellement terme échu, à date de facture
                                        </Text>
                                    </View>
                                    <View
                                        style={{
                                            fontSize: 6,
                                            padding: 7,
                                            marginTop: 10,
                                            borderTop: 0.2,
                                            borderColor: "grey",
                                        }}
                                    >
                                        <Text>
                                            Les communications hors forfait seront facturées selon les tarifs en vigueur
                                            (cf Tarif consommations téléphonique par PAYS v1.0)
                                        </Text>
                                        <Text>
                                            Chaque service livré et conforme aupré requis techniques fournis, sera
                                            réputé recetté automatiquement et donnera lieu au démarrage de la
                                            facturation du ou des service(s) concerné(s).
                                        </Text>
                                        <Text style={{ marginTop: 10 }}>
                                            En cas de souscription à une liaison/accès IP du Client auprès de SAYSE, la
                                            desserte interne devra être effectuée par le Client. La Date de livraison de
                                            l'accès IP sur le site du Client sera considérée comme la Date de la
                                            recette, même si la desserte interne n'a pas encore été réalisée.
                                        </Text>
                                    </View>
                                </View>
                            </View>
                            {/* <View style={{ marginTop: 30 }}> */}
                            {/* <View
                                    style={{
                                        textAlign: "left",
                                        fontFamily: "PoppinsBold",
                                        fontSize: 9,
                                        marginBottom: 15,
                                    }}
                                >
                                    <Text style={{ paddingLeft: 7 }}>Clauses</Text>
                                </View>
                                <View
                                    style={{
                                        fontSize: 6,
                                        paddingBottom: 5,
                                        borderRadius: 7,
                                        border: 1,
                                        borderColor: "gainsboro",
                                        backgroundColor: "white",
                                    }}
                                >
                                    {clauses.map((clause, index) => (
                                        <View
                                            wrap={false}
                                            key={index}
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                padding: 7,
                                            }}
                                        >
                                            <Text style={{ width: "30%" }}>{clause.title}</Text>
                                            <Text style={{ width: "70%" }}>{clause.describe_clauses}</Text>
                                        </View>
                                    ))}
                                </View> */}
                            {/* </View> */}
                            <View wrap={false}>
                                <View style={{ marginTop: 30 }} wrap={false}>
                                    <View
                                        style={{
                                            textAlign: "left",
                                            fontFamily: "PoppinsBold",
                                            fontSize: 9,
                                            marginBottom: 15,
                                        }}
                                    >
                                        <Text style={{ paddingLeft: 7 }}>Clauses</Text>
                                    </View>
                                    <View
                                        style={{
                                            fontSize: 6,
                                            paddingBottom: 5,
                                            borderRadius: 7,
                                            border: 1,
                                            borderColor: "gainsboro",
                                            backgroundColor: "white",
                                        }}
                                    >
                                        {clauses.map((clause, index) => (
                                            <View
                                                wrap={false}
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    padding: 7,
                                                }}
                                            >
                                                <Text style={{ width: "30%" }}>{clause.title}</Text>
                                                <Text style={{ width: "70%" }}>{clause.describe_clauses}</Text>
                                            </View>
                                        ))}
                                    </View>
                                    <View
                                        style={{
                                            textAlign: "left",
                                            fontFamily: "PoppinsBold",
                                            fontSize: 9,
                                            marginBottom: 15,
                                            marginTop: 15,
                                        }}
                                    >
                                        <Text style={{ paddingLeft: 7 }}>Accords des parties</Text>
                                    </View>
                                    <View
                                        style={{
                                            fontSize: 6,
                                            paddingBottom: 5,
                                        }}
                                    >
                                        <Text style={{ padding: 5 }}>
                                        Le présent Bon de Commande est régi par les documents contractuels en vigueur entre les Parties à sa date de signature, à savoir, selon le cas, le Contrat de Revente et/ou les Conditions Générales de Vente (CGV), ainsi que les Descriptions de Services applicables.
                                        Ces documents, préalablement acceptés, font partie intégrante du présent Bon de Commande et demeurent pleinement applicables.
                                        </Text>
                                        <Text style={{ marginTop: 10, padding: 5 }}>
                                        Le présent Bon de Commande n’emporte ni novation ni renonciation ni modification desdits documents, sauf accord exprès et écrit des Parties
                                        </Text>
                                    </View>
                                </View>
                                <View
                                    style={{
                                        height: 80,
                                        display: "flex",
                                        flexDirection: "row",
                                        marginTop: 30,
                                        fontSize: 6,
                                    }}
                                    wrap={false}
                                >
                                    <View style={{ width: "65%" }}>
                                        <Text>Pour Signataire-représentant légal:</Text>
                                        <Text style={{ marginTop: 5 }}>Fonction:</Text>
                                        <Text style={{ marginTop: 26 }}>Date:</Text>
                                    </View>
                                    <View style={{ width: "35%" }}>
                                        <Text style={{ marginLeft: 3, marginBottom: 5 }}>
                                            Cachet et signature du client
                                        </Text>
                                        <View
                                            style={{
                                                height: "90%",
                                                width: "100%",
                                                padding: 3,
                                                border: 1,
                                                borderColor: "gainsboro",
                                                borderRadius: 7,
                                                backgroundColor: "white",
                                            }}
                                        >
                                            <Text>Mention obligatoire «lu et approuvé»</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <Text
                            style={styles.pageNumber}
                            render={({ pageNumber, totalPages }) => `
                                ${
                                    pageNumber > 1
                                        ? `
                                SAYSE SAS au capital de 17 566 € - RCS de Paris 801 891 722 00010 - Nº de TVA Intracommunautaire FR 03 801 891 722
                                Siège social : 10 rue de la Paix - 75002 PARIS - Tel : 0820 432 000 - www.sayse.fr - contact@sayse.fr
                                `
                                        : ""
                                }
                            `}
                            fixed
                        />
                    </Page>
                </Document>
            );
        } else {
            return <Document />;
        }
    }
}

// @ts-ignore
const styles = StyleSheet.create({
    header: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 20,
    },
    fontBold: {
        marginLeft: "auto",
    },
    logo: {
        height: 40,
        width: 100,
    },
    txtInfoSayse: {
        fontSize: 9,
    },
    pageBackground: {
        position: "absolute",
        minHeight: "100%",
        height: "100%",
    },
    pageFiliBackground: {
        position: "absolute",
        minHeight: "90%",
        width: "100%",
        top: "45%",
        zIndex: 9999,
        transform: "rotate(-60deg)",
    },
    txtInfoClient: {
        fontFamily: "PoppinsLight",
        fontSize: 9,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        borderBottomLeftRadius: 15,
        minWidth: 260,
    },
    body: {
        width: "100%",
        padding: "0 6%",
        marginTop: 20,
        marginBottom: 10,
        display: "flex",
        flexDirection: "column",
    },
    ctnSite: {
        padding: 12,
        backgroundColor: "#fff",
        borderColor: "gainsboro",
        borderWidth: 1,
        borderRadius: 7,
        minHeight: "auto",
        breakInside: "avoid-page",
        pageBreakInside: "avoid",
    },
    headerSite: {
        display: "flex",
        flexDirection: "row",
        fontSize: 9,
        paddingBottom: 5,
        paddingTop: 7,
        borderBottomWidth: 1,
        justifyContent: "space-between",
        borderColor: "gainsboro",
    },
    footerSite: {
        display: "flex",
        flexDirection: "row",
        marginBottom: 30,
        fontFamily: "PoppinsLight",
        fontSize: 9,
        breakInside: "avoid",
    },
    row: {
        display: "flex",
        flexDirection: "row",
        fontSize: 6,
        paddingTop: 19,
        paddingBottom: 19,
        borderColor: "gainsboro",
        justifyContent: "space-between",
        borderBottomWidth: 1,
        breakInside: "avoid",
    },
    footerCase: {
        display: "flex",
        flexDirection: "row",
        paddingLeft: 5,
        paddingTop: 3,
        paddingBottom: 3,
    },
    footerCaseName: {
        display: "flex",
        flexDirection: "row",
        fontFamily: "PoppinsBold",
    },
    footer: {
        borderWidth: 1,
        borderColor: "gray",
        borderRadius: 7,
        margin: "8%",
        breakInside: "avoid",
        pageBreak: "avoid",
        padding: 10,
    },
    footerFooter: {
        display: "flex",
        flexDirection: "row",
        fontSize: 6,
        marginTop: 5,
        paddingTop: 5,
    },
    footerFooterr: {
        display: "flex",
        flexDirection: "row",
        fontSize: 6,
        marginTop: 5,
        paddingTop: 5,
    },
    rowFooter: {
        display: "flex",
        flexDirection: "row",
        fontSize: 6,
        paddingTop: 3,
        paddingBottom: 3,
    },
    footerDiscount: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        fontSize: 6,
        paddingTop: 5,
        paddingBottom: 1,
    },
    ctnResume: {
        padding: "8%",
        display: "flex",
        // backgroundColor: 'white'
    },
    resumeSection: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
    },
    pageNumber: {
        position: "absolute",
        fontSize: 6,
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: "center",
        paddingHorizontal: "6%",
        height: 30,
        overflow: "hidden",
    },
    siteContent: {
        width: "100%",
        breakInside: "avoid-page",
    },
    resumeWrapper: {
        padding: "10px 8%",
        backgroundColor: "#f8f9fa",
        minHeight: "100%",
        flex: 1,
        marginTop: 0,
        marginBottom: 0,
    },
    contentPadding: {
        padding: "2%",
        paddingTop: 0,
    },
    resumeTitle: {
        fontSize: 12,
        fontFamily: "PoppinsBold",
        marginBottom: 15,
        color: "#1162d8",
        borderBottom: "2px solid #1162d8",
        paddingBottom: 5,
        marginTop: 0,
    },
    resumeContainer: {
        border: "1px solid #e9ecef",
        borderRadius: 7,
        padding: 10,
        backgroundColor: "white",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        marginBottom: 10,
    },
    resumeContent: {
        width: "100%",
    },
    headerRow: {
        flexDirection: "row",
        borderBottom: "1px solid #dee2e6",
        paddingBottom: 10,
        paddingTop: 10,
        backgroundColor: "white",
        marginBottom: 0,
    },
    siteHeader: {
        width: "25%",
        fontSize: 10,
        fontFamily: "PoppinsBold",
        color: "#495057",
    },
    aboHeader: {
        width: "37.5%",
        fontSize: 10,
        fontFamily: "PoppinsBold",
        textAlign: "center",
        color: "#495057",
    },
    fasHeader: {
        width: "37.5%",
        fontSize: 8.5,
        fontFamily: "PoppinsBold",
        textAlign: "right",
        color: "#495057",
        whiteSpace: "nowrap",
    },
    dataRow: {
        flexDirection: "row",
        paddingVertical: 6,
        borderBottom: "1px solid #f1f3f5",
        minHeight: 18,
        marginTop: 0,
    },
    siteColumn: {
        width: "25%",
        fontSize: 8,
        paddingVertical: 2,
    },
    aboColumn: {
        width: "37.5%",
        fontSize: 8,
        textAlign: "center",
        paddingVertical: 2,
    },
    fasColumn: {
        width: "37.5%",
        fontSize: 8,
        textAlign: "right",
        paddingVertical: 2,
    },
    totalRow: {
        flexDirection: "row",
        borderTop: "2px solid #e9ecef",
        paddingTop: 10,
        paddingBottom: 5,
        marginTop: 10,
    },
    tvaRow: {
        flexDirection: "row",
        paddingTop: 4,
    },
    totalLabel: {
        width: "25%",
        fontSize: 8,
        fontFamily: "PoppinsBold",
    },
    totalAbo: {
        width: "37.5%",
        fontSize: 8,
        textAlign: "center",
        fontFamily: "PoppinsBold",
    },
    totalFas: {
        width: "37.5%",
        fontSize: 8,
        textAlign: "right",
        fontFamily: "PoppinsBold",
    },
    resumePage: {
        width: "100%",
        minHeight: "100%",
        backgroundColor: "#f8f9fa",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    baselineText: {
        position: "absolute",
        bottom: 15,
        left: 0,
        right: 0,
        textAlign: "center",
        fontSize: 6,
        color: "#495057",
        paddingHorizontal: "6%",
    },
});

export default PagePDF;
